module.exports = __webpack_public_path__ + "rfm-avatar-big-spender.svg?286a12135e47b3c51bfea86ce0ffb119";